import { createAction, props } from '@ngrx/store';

import { KeycodeCheck } from 'src/app/model/keycode-check';
import { PeopleCheck } from 'src/app/model/people-check';

export const checkKeycode = createAction('CHECK_KEYCODE', props<{ term: string }>());
export const checkKeycodeSuccess = createAction('CHECK_KEYCODE_SUCCESS', props<{ checkResult: KeycodeCheck }>());
export const checkKeycodeFailed = createAction('CHECK_KEYCODE_FAILED', props<{ errorMessage: string }>());

export const checkPeople = createAction('CHECK_PEOPLE', props<{ email: string }>());
export const checkPeopleSuccess = createAction('CHECK_PEOPLE_SUCCESS', props<{ checkResult: PeopleCheck }>());
export const checkPeopleFailed = createAction('CHECK_PEOPLE_FAILED', props<{ errorMessage: string }>());

export const searchEmail = createAction('SEARCH_EMAIL', props<{ term: string }>());
export const searchEmailSuccess = createAction('SEARCH_EMAIL_SUCCESS', props<{ emailOptions: string[] }>());
export const searchEmailFailed = createAction('SEARCH_EMAIL_FAILED', props<{ errorMessage: string }>());

export const deleteKeycode = createAction('DELETE_KEYCODE', props<{ keycode: string }>());
export const deleteKeycodeSuccess = createAction('DELETE_KEYCODE_SUCCESS', props<{ message: string }>());
export const deleteKeycodeFailed = createAction('DELETE_KEYCODE_FAILED', props<{ errorMessage: string }>());

export const deleteUser = createAction('DELETE_USER', props<{ userId: number }>());
export const deleteUserSuccess = createAction('DELETE_USER_SUCCESS', props<{ message: string }>());
export const deleteUserFailed = createAction('DELETE_USER_FAILED', props<{ errorMessage: string }>());